<div class="modal-header">
    <h3 class="modal-title text-center" [translate]="'SMARTLOCKER_PICKUP_TITLE'"></h3>
    @if (pickedUpMaterials().length === 0) {
        <span class="close" (click)="close()">&times;</span>
    }
</div>
<ng-template #loading>
    <div class="d-flex h-100 align-items-center justify-content-center">
        <progressbar [value]="100"></progressbar>
    </div>
</ng-template>
<ng-container *ngrxLet="groupedMaterialsByDoor$ as doors; suspenseTpl: loading">
    @if (doors.length === 0) {
        <div class="modal-body">
            <p [translate]="'SMARTLOCKER_NO_MATERIALS_FOUND'"></p>
        </div>
        <div class="modal-footer">
            <button
                type="button"
                class="btn btn-primary col-12 col-lg-3"
                (click)="close()"
                [translate]="'SMARTLOCKER_CANCEL_BTN_LABEL'"
            ></button>
        </div>
    } @else {
        <div class="modal-body">
            @for (door of doors; track door) {
                <div class="mt-2">
                    <pace-smartlocker-pickup-details
                        [doorData]="door"
                        [(pickedUpMaterials)]="pickedUpMaterials"
                        [smartlockerData]="smartlockerData"
                    ></pace-smartlocker-pickup-details>
                </div>
            }
        </div>
        <div class="modal-footer">
            <button
                type="button"
                class="btn btn-primary col-12 col-lg-3"
                (click)="smartlockerPickupCompleted()"
                [disabled]="pickedUpMaterials().length === 0"
                [translate]="'SMARTLOCKER_DONE_BTN_LABEL'"
            ></button>
        </div>
    }
</ng-container>
